import { useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { DashboardLayout, PageTitle } from '../components'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { ComingSoonContainer } from '@/components/organisms'
import { useDownloadEmailExport } from '@/features/Reporting/hooks/useDownloadEmailExport'

export default function Dashboard() {
    const { t } = useTranslation('translations')
    const navigate = useNavigate()

    const search = useSearch({ from: '/_layout/dashboard' })
    const downloadExportIdRef = useRef(search.downloadExportId)

    const clearDownloadExportId = useCallback(() => {
        void navigate({
            to: '/dashboard',
            search: { downloadExportId: undefined },
            replace: true,
        })
    }, [navigate])

    useDownloadEmailExport({
        exportId: downloadExportIdRef.current,
        onComplete: clearDownloadExportId,
    })

    return (
        <div className="grid h-full grow grid-cols-[100%] grid-rows-[auto_1fr]">
            <PageTitle
                label={t('sidebar_menu.dashboard')}
                labelTestId="page-title-dashboard"
            />

            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <ComingSoonContainer />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <DashboardLayout />
            </RoleRestrictedContent>
        </div>
    )
}
